import { Component } from '@angular/core';


@Component({
  selector: 'app-terms-of-use-text',
  templateUrl: './terms-of-use-text.component.html',
  styleUrls: ['./terms-of-use-text.component.scss']
})
export class TermsOfUseTextComponent {
}
